const actions = {
  async updateUserHandler({ dispatch }, [file, data]) {
    let requests = [
      dispatch('api/genericHandler', [
        'users/updateMe',
        data,
        () => dispatch('popups/show/error/updating', 'Your Profile', {root: true})
      ], {root: true})
    ]

    // can only upload if there's a file to upload
    if (file) {
      requests.push(
        dispatch('api/genericHandler', [
          'media/uploadAvatar',
          file,
          () => dispatch('popups/show/error/uploading', 'your Avatar', {root: true})
        ], {root: true})
      )
    }
    // Promise.all is a handy function that takes an array of promises, and returns a promise that will only resolve when
    // all promises in the array have resolved.
    // the resolved value of that promise is an array of resolved values for each promise in the input array

    // this allows us to kick off both requests at the same time, and then wait until they're both done before proceeding. very handy.
    let res = await Promise.all(requests)
    // uploadRes is conditionally added to the requests array, so may be undefined

    dispatch('updateUserCallback', res)

    return res
  },
  async updateUserCallback({ commit, dispatch }, [dataRes = {}, uploadRes = {}]) {
    if (dataRes.success) {
      dispatch('popups/show/success/updating', 'Profile info', {root: true})
      commit('USER', dataRes.success)
      // handles if uploadRes is undefined, ensuring the below code (which would otherwise throw) doesn't run
    }
    if (!uploadRes || uploadRes.error) dispatch('popups/show/error/updating', 'Avatar', {root: true})
  },

  async confirmDeleteAvatar({dispatch}, callback) {
    dispatch('popups/user/confirmDeleteAvatar', () => dispatch('deleteAvatarCallback', callback), {root: true})
  },
  async deleteAvatarCallback({ commit, dispatch }, callback) {
    let res = await dispatch('api/media/deleteAvatar', null, {root: true})
    dispatch('api/users/deleteAvatar', null, {root: true})
    if(res?.success) {
      commit('USER', res.success)
      if(callback) callback()
      dispatch('popups/show/success/deleting', 'Avatar', {root: true})
    }
    else dispatch('popups/show/error/deleting', 'Your avatar', {root: true})
  },
}

export default {
  actions
};
